<template>
	<div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"
					   rowKey="pid" :pagination="false" :scoll="{y:600}">
					<span slot="createtimeSlot"  slot-scope="text, record">
						{{getFormatter(record.create_time)}}
					</span>
		</a-table>
	</div>
</template>

<script>
	const columns = [
		{ title: '操作时间',width:160,scopedSlots: { customRender: 'createtimeSlot' }},
		{ title: '操作人', dataIndex: 'create_user_name'},
		{ title: '表户号', dataIndex: 'customer_num'},
		{ title: '新表地址', dataIndex: 'change_meter_addr'},
		{ title: '旧表地址', dataIndex: 'old_meter_addr',},
		{ title: '新钢印号', dataIndex: 'change_meter_steel_num'},
		{ title: '旧钢印号', dataIndex: 'old_meter_steel_num',},
		{ title: '新换表底数', dataIndex: 'change_meter_end_read'},
		{ title: '旧换表底数', dataIndex: 'old_meter_end_read'},
	];
	export default{
		props:[
			'meterId',
		],
		data(){
			return {
				columns,
				list:[],
				loading:true,
			}
		},
		methods:{
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER__CHANGE_HISTORY_URL);
				let param = {meterId:this.meterId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			getFormatter:function(dateTime){
				let date = new Date(dateTime);
				return this.Config.formatDate(date);
			}
		},
		mounted() {
			this.queryDataList();
		}
	}
</script>

<style>
</style>
